import { createContext, useContext, useState } from "react";
import { NodeData } from "./data";
import { useDebounceValue } from "@/hooks/use-debounce-value";

export const useComplaintCode = () => {
  const [debouncedValue, setValue] = useDebounceValue("", 500);
  const [selected, setSelected] = useState<NodeData | null>(null);

  return { filter: debouncedValue, selected, setSelected, setValue };
};

type ComplaintCodeContextType = ReturnType<typeof useComplaintCode>;

const ComplaintCodeContext = createContext<ComplaintCodeContextType | undefined>(undefined);

export const ComplaintCodeProvider = ({ value, children }: { value: ComplaintCodeContextType, children: React.ReactNode }) => {
  return (
    <ComplaintCodeContext.Provider value={value}>
      {children}
    </ComplaintCodeContext.Provider>
  );
};

export const useComplaintCodeContext = () => {
  const context = useContext(ComplaintCodeContext);
  if (!context) {
    throw new Error("useComplaintCodeContext must be used within a ComplaintCodeProvider");
  }
  return context;
};